import { notification } from "antd";
import React from "react";
import { ContentRoute } from "../../../../_metronic/layout";
import { hasPermissions } from "../constants";

export const DefaultPageOnDenied = ({ reqPermissions }) => {
  reqPermissions?.map((reqPermission) =>
    notification.error({
      type: "error",
      message: `You need permission "${reqPermission.title}" to visit this resource.`,
    })
  );

  return (
    <div
      style={{
        backgroundColor: "#fff",
        height: "70vh",
        width: "70vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "darkred",
        fontSize: "16px",
      }}
    >
      <>Permission Denied </>
    </div>
  );
};

const AuthorizeContentRoute = ({ path, component, permissions }) => {
  try {
    const [success, failedPermissions] = hasPermissions(permissions);
    if (success) {
      return <ContentRoute path={path} component={component} />;
    } else {
      return <ContentRoute path={path} render={() => <DefaultPageOnDenied reqPermissions={failedPermissions} />} />;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export default AuthorizeContentRoute;
